angular.module('rjmNg.directives').directive "createMetric", [
  () ->
    restrict: "E"
    templateUrl: "directive.createMetric.html"
    replace: false
    controllerAs: 'view'
    scope: {}
    bindToController: true
    controller: [
      "$q"
      "$routeParams"
      "$window"
      "notification"
      "Metrics"
      "app"
      "StructureCache"
      "errorConstants"
      "$url"
      (
        $q
        $routeParams
        $window
        notification
        Metrics
        app
        StructureCache
        errorConstants
        $url
      ) ->

        view = @
        view.loading = true
        view.isAdmin = app.isAdminUser()
        view.clientId = $routeParams.clientId

        view.tables = []
        view.metrics = []
        view.tableSearchTerm = ""

        notificationTimeout = 15

        _init = ->
          $q.all([
            Metrics.get(view.clientId),
            StructureCache.getStructure(),
          ]).then ([metrics, structure]) ->
            view.metrics = metrics
            view.tables = []
            view.tables.push table for id, table of structure.tables
            view.loading = false
          .catch (error) ->
            view.loading = false
            notification.error("Server Error",
              errorConstants.SERVER_ERROR_MESSAGE,
              "metrics",
              null,
              notificationTimeout)

        _createMetric = (metric) ->
          
          Metrics.create(view.clientId, metric)
          .then (value, responseHeaders) ->
            # Redirect the user to the edit page for the new metric
            if (value.id?)
              $window.location = $url("/settings/#{view.clientId}/trend/#{value.id}/edit/")
            else
              notification.error("Server Error",
                errorConstants.SERVER_ERROR_MESSAGE,
                "metrics",
                null,
                notificationTimeout
              )
              view.loading = false
          .catch (response) ->
            notification.error("Server Error",
              errorConstants.SERVER_ERROR_MESSAGE,
              "metrics",
              null,
              notificationTimeout
            )
            view.loading = false

        view.createMetric = (table) ->
          view.loading = true

          metric = Metrics.generateBaseMetric(table, view.metrics)
          if not metric
            notification.error("Table Error",
              "This table has no primary keys.  Please add a primary key to this table in order to create a metric.",
              "metrics",
              null,
              notificationTimeout
              )
            view.loading = false
          else
            _createMetric(metric)

        _init()

        view
    ]
]
